/* iceberg-ui */
import { Box } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Typography } from '@mui/material';
import { ApplicationBubbles } from 'application/Shared/Components/Avatars';

/*  Shared  */
import { Confirm } from 'application/Shared/Modals/Confirm';
import { Application } from 'application/Shared/types/application';

/*  React  */
import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { WorkatoActions } from '../types';

/* internal */
import { SaasOpsActionItemStatus, SaasOpsActionItemsState } from './types';

export const SkippedAppsModal = ({
    goToNextApp,
    setCurrentAppId,
    setOpenSkippedAppsModal,
    setSaasOpsActionItemsState,
    skippedApps,
    saasOpsAction
}: {
    goToNextApp: (updatedAppState?: SaasOpsActionItemsState) => void;
    setCurrentAppId: Dispatch<SetStateAction<string>>;
    setOpenSkippedAppsModal: Dispatch<SetStateAction<boolean>>;
    setSaasOpsActionItemsState: Dispatch<
        SetStateAction<SaasOpsActionItemsState>
    >;
    skippedApps: SaasOpsActionItemsState;
    saasOpsAction: WorkatoActions;
}) => {
    const { t } = useTranslation();

    // ApplicationBubbles needs an array of only the tenantApp.application objects
    const apps = skippedApps.map<Application>(
        (item) => item.recipe.application!
    );

    return (
        <Confirm
            data-testid="saasOpsActionSkipAppsModal"
            data-trackid={`saasOps_${saasOpsAction}_SkipAppsModal`}
            modalOpen
            promptConfirmFn={() => {
                setOpenSkippedAppsModal(false);
                setSaasOpsActionItemsState((prevTenantAppState) => {
                    const updatedState = prevTenantAppState.map((appState) => {
                        if (
                            appState.status === SaasOpsActionItemStatus.Skipped
                        ) {
                            return {
                                ...appState,
                                status: SaasOpsActionItemStatus.Removed
                            };
                        }

                        return appState;
                    });

                    goToNextApp(updatedState);
                    return updatedState;
                });
            }}
            promptCancelFn={() => {
                setCurrentAppId(skippedApps[0].applicationId);
                setOpenSkippedAppsModal(false);
            }}
            promptTitle={t('SaasOps.skippingAppsModal.title')}
            promptText={
                <Box display="flex" flexDirection="column">
                    <Typography sx={{ mb: '16px' }}>
                        {t(
                            `SaasOps.skippingAppsModal.${saasOpsAction}.message`,
                            {
                                count: apps.length
                            }
                        )}
                    </Typography>
                    <Box display="flex" justifyContent="center">
                        <ApplicationBubbles max={3} applications={apps} />
                    </Box>
                </Box>
            }
            textConfirmButton={t('SaasOps.skippingAppsModal.remove')}
            textCancelButton={t('SaasOps.skippingAppsModal.reviewAgain')}
        />
    );
};
